module.exports = __webpack_public_path__ + "static/media/ekoology.fc19efb3.png";